export const AUTH_CONFIG = {
  domain: 'fizbuz.auth0.com',
  //roleUrl: "https://rbac-tutorial-app/role",
  clientId: 'NdvY3uAHQSF7tuGx4554V6dGbDITzXGu',
  audience: 'https://alpha.fizbuz.com',
}
